import gql from 'graphql-tag'

import { FRAGMENTS_HEROES, FRAGMENTS_SECTIONS } from './shared.gql'

export const FRAGMENT_PAGE = gql`
  ${FRAGMENTS_HEROES}
  ${FRAGMENTS_SECTIONS}

  fragment PageDto on Page {
    __typename
    id
    createdAt
    updatedAt
    slug
    title
    excerpt
    hero {
      ...HeroSplit
      ...HeroOverlay
    }
    sections {
      ...SectionBasic
      ...SectionBoxedText
      ...SectionContact
      ...SectionContentMedia
      ...SectionContentSplit
      ...SectionFilterItems
    }
  }
`

export const QUERY_PAGE = gql`
  ${FRAGMENT_PAGE}
  query page($locale: LocaleInputType!, $where: Page_where!, $draft: Boolean!) {
    Pages(locale: $locale, draft: $draft, where: $where, trash: false) {
      docs {
        ...PageDto
      }
    }
  }
`
